import * as React from "react";
import "./Home.css";
import Header from "./Header.js";
import Footer from "./Footer.js";

function Home() {
  return (
    <>
      
              <Header />
      <div className="kiy-home">
        <div className="div background-container">
          <div className="small-container">
            <div className="title-section">
              <div className="image" />
              <div className="content">
                <div className="trust-no-othersbut-yourself">
                  Trust No Others but Yourself
                </div>
                <br className="responsive-br"/>
                <br className="responsive-br"/>
                <div className="yourcryptocurrenciesyourdigitalassetsyoursensitivedatayourprivacyinformationandyouridentityinformation">
                with your digital assets, private data, or identity information.
                </div>
              </div>
              {/* <div className="actions">
                <a 
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=partnership@keepityourself.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{
                    textDecoration: "none", // Remove underline
                    color: "black" // Set font color to black
                  }}
                >
                  <div className="button">Partner Up with KIY</div>
                </a>
              </div> */}
              <br />
            </div>
            <img
              loading="lazy"
              srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b"
              className="img-2"
              alt="Image representing Trust No Others but Yourself"
            />
          </div>
          <br/>
          <br className="responsive-br"/>
          <br  className="responsive-br"/>
          <br  className="responsive-br"/>
          <div className="relyonsomeonewhotechnicallybetterthanyoutosafeguardyourassetsoryourprivacyyouareneversafe-doityourselfandkeepsecuritytoyourself">
            If you rely on someone technically better than you to safeguard your assets or privacy, you will never be truly secure.
          </div>
          <br />
          <br/>
          <div className="if-you-involve-someone">Keep security to yourself.</div>
          <br  className="responsive-br"/>
          <div className="kiy-keep-it-yourself">KIY, Keep It Yourself</div>
          <br  className="responsive-br"/>
          <div className="your-web-3-securitypartnerhelpyoutosafeguardyourassetsyourdataandyouridentityyourself">
            your Web3 security partner
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Home;
